<div class="bg-container">
    <div class="login-header">
        <img [class]="companyImage === '../../assets/img/1-ez-docs-white.png' ? 'company-img ez-docs' : 'company-img '"
            src="{{ companyImage }}" alt="ddj logo" [routerLink]="['login']" />
        <img id="product-image"
            [class]="productImage === '../../assets/img/ez-docs-logo-white.png' ? 'product-img ez-docs' : 'product-img'"
            src="{{ productImage }}" alt="unite digital logo" />
    </div>

    <router-outlet></router-outlet>

    <app-footer></app-footer>
</div>